import React from 'react';
import styles from './HeroText.css';

const HeroText = ({ ordernum }) => ({
  render() {
    if (ordernum) {
      return (
        <div className={styles.heroText}>
          <h1 className={styles.header}>Your order has been placed!</h1>
          <p className={styles.order}>Order# {ordernum}</p>
        </div>
      );
    }
    return (
      <div className={styles.heroText}>
        <h1 className={styles.header}>Fast Fill</h1>
        <p className={styles.description}>
          Easily fill your pet or horse&apos;s prescription
        </p>
        <p className={styles.description}>with the click of a button.</p>
      </div>
    );
  },
});

export default HeroText;



// WEBPACK FOOTER //
// ./src/components/HeroText.jsx